<agr-page-toolbar [pageTitle]="pageTitle()">
  <div class="page">
    <div class="page-header">
      <span class="text-color--primary-500 title">{{ 'downyMildew.advice.title' | translate }}</span>
      <app-crop-year-selector [readOnly]="true" />
    </div>
    <div class="flex flex--row full-width">
      <mat-tab-group [selectedIndex]="selectedTabIndex()" (selectedTabChange)="onTabChange($event)">
        <mat-tab [label]="'downyMildew.advice.overview.title' | translate" />
        <mat-tab [label]="'downyMildew.advice.insights.title' | translate" />
      </mat-tab-group>
    </div>
    @if (selectedTabIndex() === 0) {
      <ng-container *ngTemplateOutlet="adviceOverview" />
    } @else if (selectedTabIndex() === 1) {
      <ng-container *ngTemplateOutlet="insight" />
    }
  </div>
</agr-page-toolbar>

<ng-template matTabContent #adviceOverview>
  <app-downy-mildew-advice-overview (adviceClick)="onCropFieldClick($event)" />
</ng-template>

<ng-template matTabContent #insight>
  <app-downy-mildew-insight-page style="width: 100%" />
</ng-template>
